import React from "react";

export default ({ location: { pathname } }) => <h1>{pathname} Coming Soon</h1>;
